import { render } from "./SingleNewsView.vue?vue&type=template&id=15242579"
import script from "./SingleNewsView.vue?vue&type=script&lang=js"
export * from "./SingleNewsView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tmulag_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__